import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { A11yModule } from '@angular/cdk/a11y';
import { ModalBaseComponent } from 'src/app/shared/components/modal-base/modal-base.component';

@Component({
  selector: 'app-domain-owner-modal',
  imports: [TranslateModule, CommonModule, A11yModule, ModalBaseComponent],
  templateUrl: './domain-owner-modal.component.html',
})
export class DomainOwnerModalComponent {
  protected dialogRef = inject(DialogRef);
  protected data = inject(DIALOG_DATA);
}
